module.exports = __webpack_public_path__ + "static/media/check-circled.c93c4254.svg";